import API from "../index";

export const getUsersService = async (payload) => {
  return API.get("/user/list", {
    params: payload
  });
};
